"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomHSBCRequiredIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const axios_1 = require("axios");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const zod_1 = require("zod");
const strings_1 = require("../../../../../../../constants/strings");
const SecuritySecure_1 = __importDefault(require("../../../../../../../hsbc_img/img/SecuritySecure"));
const sessionQuery_1 = require("../../../../../../../queries/sessionQuery");
const routerUtils_1 = require("../../../../../../../router/routerUtils");
const zustandStore_1 = require("../../../../../../../zustandStore");
const pageSpinner_1 = __importDefault(require("../../../../../../molecules/pageSpinner"));
const formWrapper_1 = __importDefault(require("../../../formWrapper"));
const useValidation_1 = require("../../../hooks/useValidation");
const formInput_1 = __importDefault(require("../../common/formInput"));
const termsAndConditionsFormFooter_1 = __importDefault(require("../../common/termsAndConditionsFormFooter"));
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
const CustomHSBCRequiredIcon = () => ((0, jsx_runtime_1.jsx)(SecuritySecure_1.default, { style: { width: '1.12rem', marginLeft: '4px', verticalAlign: 'middle' } }));
exports.CustomHSBCRequiredIcon = CustomHSBCRequiredIcon;
const tempPasswordSchema = zod_1.z.object({
    email: zod_1.z.string().email('Invalid email address'),
    tempPassword: zod_1.z.string().min(8, 'Activation code must be at least 8 characters'),
});
const TemporaryPasswordForm = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data, isLoading, error } = initialData || {};
    const [formState, setFormState] = (0, react_1.useState)({
        email: data?.username || '',
        tempPassword: '',
    });
    const { setCurrentStep, steps, setPageLoading, setStepsData, setDialog, closeDialog } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const [activationCodeError, setActivationCodeError] = (0, react_1.useState)(null);
    const { userId, activationToken } = (0, react_router_1.useParams)();
    const { validateField, clearFieldError, fieldErrors, validateAllSchema } = (0, useValidation_1.useValidation)();
    const navigate = (0, react_router_1.useNavigate)();
    const activateUserTemporaryPassword = (0, sessionQuery_1.useRequestActivationWithTemporaryPasswordQuery)();
    const { navigateToLockedAccountMessage } = (0, routerUtils_1.useSigninMessageNavigation)();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => {
            const updatedState = { ...prev, [name]: value };
            clearFieldError(name);
            return updatedState;
        });
    };
    const handleBlur = (e) => {
        if (e) {
            const { name = '' } = e.target;
            validateField(tempPasswordSchema, name, formState);
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        validateAllSchema(tempPasswordSchema, formState);
        if (!data) {
            logger.error('data is missing');
            return;
        }
        setPageLoading(true);
        const options = {
            activationToken: activationToken || '',
            userId: userId || '',
            temporaryPassword: formState.tempPassword,
        };
        activateUserTemporaryPassword.mutate(options, {
            onSuccess: async () => {
                setActivationCodeError(null);
                setCurrentStep(steps.currentStep + 1);
                setStepsData({
                    tempPassword: formState.tempPassword,
                });
            },
            onError: error => {
                if ((0, axios_1.isAxiosError)(error) &&
                    (error.response?.status === 400 ||
                        error.response?.data === 'Invalid temporary password or activation token provided')) {
                    setActivationCodeError((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You've entered the wrong activation code, ", (0, jsx_runtime_1.jsx)("br", {}), "please try again."] }));
                    // Add a custom style to the FormInput for this specific error
                    const tempPasswordInput = document.querySelector('input[name="tempPassword"]');
                    if (tempPasswordInput) {
                        const errorElement = tempPasswordInput.parentElement?.querySelector('.MuiFormHelperText-root');
                        if (errorElement) {
                            errorElement.innerHTML = "You've entered the wrong activation code,<br>please try again.";
                        }
                    }
                }
                else if ((0, axios_1.isAxiosError)(error) &&
                    error.response?.status === 403 &&
                    error.response?.data?.errorCode === 'LOCKED_ACCOUNT') {
                    navigateToLockedAccountMessage('activation');
                    return;
                }
                else {
                    setDialog({
                        type: strings_1.notificationStrings.WARNING,
                        message: lexico.trc('Warning message', 'Invalid activation code. Please try again.'),
                        open: true,
                        actionText: 'TRY AGAIN',
                        showCancel: false,
                        onAccept: closeDialog,
                    });
                }
                setFormState(prevState => ({
                    ...prevState,
                    tempPassword: '',
                }));
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    (0, react_use_1.useEffectOnce)(() => {
        if (!data) {
            return;
        }
        if (data.activationCodeAttemptsExceeded) {
            navigateToLockedAccountMessage('activation');
            return;
        }
    });
    (0, react_use_1.useEffectOnce)(() => {
        if (!error) {
            return;
        }
        void navigate('/signin/message', {
            state: {
                heading: lexico.tr('Sorry, we are having technical difficulties. Please try again later.'),
                message: lexico.trc('Error message', 'The link to activate your account is invalid or has expired. Please check with the person who invited you to get another invitation.'),
            },
        });
    });
    return ((0, jsx_runtime_1.jsxs)(formWrapper_1.default, { formName: "Enter your activation code", onSubmit: handleSubmit, submitButton: {
            label: 'Verify and Continue',
            // isDisabled: !tempPasswordSchema.safeParse(formState).success,
            isDisabled: false,
        }, isFormPending: activateUserTemporaryPassword.isPending, formFooter: (0, jsx_runtime_1.jsx)(termsAndConditionsFormFooter_1.default, {}), children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", style: {
                    fontStyle: 'normal',
                    lineHeight: '18px',
                    color: '#000000',
                }, children: "To verify your email address and continue with the registration, please enter the activation code." }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Email", name: "email", type: "email", value: formState.email, error: fieldErrors['email'], onBlur: handleBlur, readOnly: true, endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(exports.CustomHSBCRequiredIcon, {}) }), onChange: handleInputChange }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Activation Code", name: "tempPassword", type: "password", value: formState.tempPassword, error: activationCodeError || fieldErrors['tempPassword'], onChange: handleInputChange, onBlur: handleBlur }), isLoading ? (0, jsx_runtime_1.jsx)(pageSpinner_1.default, { isLoading: true }) : null] }));
};
exports.default = TemporaryPasswordForm;
